import { ClientConfig, DEFAULT_CLIENT_CONFIG } from './config.base';
import { navigationRoutes as BaseLinks, RouteParams } from './links.base';

export const CLIENT_CONFIG: ClientConfig = {
  clientName: 'rysevision',
  ...DEFAULT_CLIENT_CONFIG,
  logo: {
    lightLogo: 'assets/rysevision/light-logo.png',
    darkLogo: 'assets/rysevision/dark-logo.png',
    alt: 'Ryse Vision',
    width: '140px',
    height: '25px',
    loginPageWidth: '120px',
    loginPageHeight: '22px',
  },
  showCustomLoginPage: true,
};

export const navigationRoutes: RouteParams[] = CLIENT_CONFIG.allowedRoutes.map((x) => BaseLinks[x]);
